export function parseCommaSeparatedIds(
  raw: string | null | undefined
): number[] {
  if (raw == null || typeof raw !== 'string') return [];
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
    .map((s) => Number(s))
    .filter((n) => Number.isFinite(n));
}
